import React, { Component } from 'react'
import ParadigmaModal from '../../components/ParadigmaModal/ParadigmaModal'
import api from '../../api/api'
import { FormFeedback, Input } from 'reactstrap';
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker"
import ParadigmaAsyncSeeker2 from "../../components/ParadigmaAsyncSeeker_v2/ParadigmaAsyncSeeker"
import DatePicker from 'react-datepicker';
import InputMask from 'react-input-mask';
import moment from 'moment'

import './Modal.css'

export default class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
          titulo: '',
          dependencia_convenio_id: null,
          referencia: '',
          tipo_convenio_id: null,
          fecha_inicio: moment(),
          fecha_vencimiento: moment(),
          contrapartes_id: [],
          contrapartes: [],
          participantes_id: [],
          participantes: [],
          proyecto_id: '',
          documentos: [],
          add_documentos: null,
          documentos_url: [],
          errors:{},
          postVariables: ['titulo', 'dependencia_convenio_id', 'referencia', 'tipo_convenio_id', 'contrapartes_id', 'participantes_id', 'proyecto_id']
        };
    }

    resetState=()=>{
      this.setState({
        titulo: '',
        dependencia_convenio_id: null,
        referencia: '',
        tipo_convenio_id: null,
        contrapartes_id: [],
        contrapartes: [],
        fecha_inicio: moment(),
        fecha_vencimiento: moment(),
        participantes_id: [],
        participantes: [],
        proyecto_id: '',
        errors:{},
        documentos:[],
        add_documentos: null,
        documentos_url:[],
      })
    }


    onValidation = () => {
      const {titulo, dependencia_convenio_id, contrapartes_id, participantes_id, tipo_convenio_id} = this.state;
      let errors = {};

      if (!!!titulo) {errors.titulo = 'Ingrese un valor valido';}
      if (!!!dependencia_convenio_id) {errors.dependencia_convenio_id = 'Ingrese un valor valido';}
      if (!contrapartes_id || contrapartes_id.length === 0) {errors.contrapartes_id = 'Ingrese un valor valido';}
      if (!participantes_id || participantes_id.length === 0) {errors.participantes_id = 'Ingrese un valor valido';}
      if (!!!tipo_convenio_id) {errors.tipo_convenio_id = 'Ingrese un valor valido';}

      this.setState({ errors });
      return Object.keys(errors).length == 0;
    }


    getData = () => {
      const {postVariables} = this.state;
      const data = {}
      postVariables.forEach((key)=>{
        data[key]=this.state[key]
      })
      data['fecha_inicio']=this.state.fecha_inicio.format("YYYY-MM-DD")
      data['fecha_vencimiento']=this.state.fecha_vencimiento.format("YYYY-MM-DD")
      data['documentos']=this.state.documentos
      data['add_documentos']=this.state.add_documentos
      return data
    }

    setData = (data) => {
      try{

        console.log("DATA\n", data)

        this.setState({
          titulo: data.titulo,
          dependencia_convenio_id: data.dependencia_convenio ? data.dependencia_convenio.pk : null,
          referencia: data.referencia,
          tipo_convenio_id: data.tipo_convenio ? data.tipo_convenio.pk : null,
          participantes_id: data.participantes ? data.participantes.map(participante => participante.pk) : [],
          contrapartes_id: data.contrapartes ? data.contrapartes.map(contraparte => contraparte.pk): [],
          fecha_inicio: moment(data.fecha_inicio),
          fecha_vencimiento: moment(data.fecha_vencimiento),
          proyecto_id: data.proyecto ? data.proyecto.pk : '',
          documentos: data.documentos ? data.documentos : [],
          // documentos_url: data.documentos ? [...data.documentos.map(x => x.path)] : [],
        })
      } catch (err){
        console.log('Error cargando los datos en el formulario.')
        console.log(err)
      }
    }

    getModalVars = () => {
    const { action, onClose } = this.props;
      if (action=="CREATE"){
        return {
          action,
          postUrl: api.convenios.convenios.create,
          buttonTitle: "Nuevo",
          onClose: () => this.resetState(),
          onPreSubmit: () => this.getData(),
          onValidation: () => this.onValidation(),
          onSubmit: () => this.props.onSubmit(),
          fileUploader: true,
          disabled: false,
          successMessage: "El convenio ha sido creado con éxito.",
          title: "Nuevo convenio",
          buttonIcon: "fa fa-plus fa-lg",
          saveButton: true,
          closeButton: true,
          className: "ui-modal-dialog ui-modal-lg",
        }
      } else if (action=="EDIT"){
        return {
          action,
          postUrl: api.convenios.convenios.detail,
          getUrl: api.convenios.convenios.detail,
          fileUploader: true,
          buttonTitle: "Editar",
          id: this.props.id,
          onGotData: (data) => this.setData(data),
          onPreSubmit: () => this.getData(),
          onClose: () => this.resetState() & (onClose && onClose()),
          onValidation: () => this.onValidation(),
          onSubmit: () => this.props.onSubmit(),
          disabled: false,
          successMessage: "El convenio ha sido editado con éxito.",
          title: "Editar convenio",
          buttonIcon: "fa fa-pencil fa-lg",
          saveButton: true,
          closeButton: true,
          className: "ui-modal-dialog ui-modal-lg",
      }
    }  else if (action=="DETAIL") {
      return {
        action,
        getUrl: api.convenios.convenios.detail,
        buttonTitle: "Ver",
        id: this.props.id,
        onGotData: (data) => this.setData(data),
        onClose: () => this.resetState() & (onClose && onClose()),
        disabled: true,
        title: "Detalles convenio",
        buttonIcon: "fa fa-search fa-lg",
        saveButton: false,
        closeButton: true,
        className: "ui-modal-dialog ui-modal-lg",
      }
    } else if (action=="DELETE") {
      return {
        action,
        getUrl: api.convenios.convenios.detail,
        postUrl: api.convenios.convenios.delete,
        id: this.props.id,
        onGotData: (data) => this.setData(data),
        onClose: () => this.resetState() & (onClose && onClose()),
        onSubmit: () => this.props.onSubmit(),
        disabled: true,
        title: "Eliminar convenio",
        successMessage: "El convenio ha sido eliminado con éxito.",
        buttonIcon: "fa fa-trash fa-lg",
        danger: true,
        closeButton: true,
        saveButton: true,
        buttonClass: "btn-danger",
        saveButtonLabel: "Eliminar",
        buttonTitle: "Eliminar",
        className: "ui-modal-dialog ui-modal-lg",
      }
    }
  }
    onChangeField(field, value) {
      this.setState(prevState => {
        let errors = prevState.errors;
        if (errors) errors[field] = null;
        prevState.errors = errors;
        prevState[field] = value;
        return prevState;
      });
    }

    removeDocument=(evt)=>{
      const filename = evt.currentTarget.getAttribute('data-remove')
      const newDocumentos=this.state.documentos.filter(elemento => elemento.filename != filename)
      this.setState({
        documentos:newDocumentos
      })
    }


    render() {
      const modalVars = this.getModalVars();
      const {errors} = this.state;
    return (
      <ParadigmaModal {...modalVars}>
        <div className="ui-form">
          {this.props.action=="DELETE" &&
            <div className="ui-alert ui-alert-danger">
              Esta acción eliminará el convenio seleccionado y sus datos asociados.
            </div>
          }

          <div className="ui-section-grid ">
            <section className="ui-section-block ui-section-span-2">
              <h5 className="ui-section-label">Identificación</h5>
              <div className="ui-row-1">
                <div className="ui-field">
                  <label>Título</label>
                  <Input
                    type="text"
                    name="titulo"
                    autoFocus={this.props.action == "CREATE"}
                    data-auto-focus={this.props.action == "CREATE" ? "true" : null}
                    value={this.state.titulo}
                    disabled={modalVars.disabled}
                    onChange={(e)=> this.onChangeField('titulo', e.target.value)}
                  />
                  <FormFeedback className={(errors.titulo != undefined ? "d-block" : "")}>{errors.titulo}</FormFeedback>
                </div>
              </div>
              <div className="ui-row-2">
                <div className="ui-field">
                  <label>Dependencia</label>
                  <ParadigmaAsyncSeeker
                    disabled={modalVars.disabled}
                    clearable={false}
                    url={api.proyectos.cargadatos.convenios.dependencias.select}
                    parameters={{
                      paginationEnabled: false,
                      sort: ['nombre']
                    }}
                    nombreField="nombre"
                    value={this.state.dependencia_convenio_id}
                    onChange={data => {
                      this.onChangeField('dependencia_convenio_id', (data) ? data.pk : null);
                      this.setState({ dependencia_convenio_id: (data) ? data.pk : null })
                    }}
                  />
                  <FormFeedback className={(errors.dependencia_convenio_id != undefined ? "d-block" : "")}>{errors.dependencia_convenio_id}</FormFeedback>
                </div>
                <div className="ui-field">
                  <label>Tipo</label>
                  <ParadigmaAsyncSeeker
                    disabled={modalVars.disabled}
                    clearable={false}
                    url={api.proyectos.cargadatos.convenios.tipos.select}
                    parameters={{
                      paginationEnabled: false,
                      sort: ['nombre']
                    }}
                    nombreField="nombre"
                    value={this.state.tipo_convenio_id}
                    onChange={data => {
                      this.onChangeField('tipo_convenio_id', (data) ? data.pk : null);
                      this.setState({ tipo_convenio_id: (data) ? data.pk : null })
                    }}
                  />
                  <FormFeedback className={(errors.tipo_convenio_id != undefined ? "d-block" : "")}>{errors.tipo_convenio_id}</FormFeedback>
                </div>
              </div>
              <div className="ui-row-1">
                <div className="ui-field">
                  <label>Proyecto (opcional)</label>
                  <ParadigmaAsyncSeeker
                    url={api.proyectos.solicitudes.select}
                    value={this.state.proyecto_id}
                    disabled={modalVars.disabled}
                    onChange={(e)=> {
                      this.setState({proyecto_id: e ? e.pk : ''})
                    }}
                  />
                </div>
              </div>
            </section>

            <section className="ui-section-block">
              <h5 className="ui-section-label">Personas y entidades</h5>
              <div className="ui-row-1">
                <div className="ui-field">
                  <label>Participantes</label>
                  <ParadigmaAsyncSeeker2
                    multiselect={true}
                    disabled={modalVars.disabled}
                    clearable={false}
                    url={api.usuarios.personal.select}
                    parameters={{
                      paginationEnabled: false,
                      sort: ['fullname']
                    }}
                    displayField="fullname"
                    value={this.state.participantes_id ? this.state.participantes_id : []}
                    onChange={data => {
                      this.onChangeField('participantes_id', (data) ? data.map(participante => participante.id) : []);
                      this.setState({ participantes: (data) ? data : [] })
                    }}
                  />
                  <FormFeedback className={(errors.participantes_id != undefined ? "d-block" : "")}>{errors.participantes_id}</FormFeedback>
                </div>
              </div>
              <div className="ui-row-1">
                <div className="ui-field">
                  <label>Contraparte/s</label>
                  <ParadigmaAsyncSeeker
                    multiselect
                    fieldName="contrapartes"
                    url={api.clientes.empresas.select}
                    disabled={modalVars.disabled}
                    value={this.state.contrapartes_id ? this.state.contrapartes_id : []}
                    onChange={data => {
                      this.onChangeField('contrapartes_id', (data) ? data.map(contraparte => contraparte.pk) : []);
                      this.setState({ contrapartes: (data) ? data : [] })
                    }}
                  />
                  <FormFeedback className={(errors.contrapartes_id != undefined ? "d-block" : "")}>{errors.contrapartes_id}</FormFeedback>
                </div>
              </div>
            </section>
            <section className="ui-section-block">
              <h5 className="ui-section-label">Vigencia</h5>
              <div className="ui-row-2">
                <div className="ui-field">
                  <label>Fecha de inicio</label>
                  <DatePicker
                    selected={this.state.fecha_inicio}
                    onChange={(e) => this.setState({ 'fecha_inicio': moment(e) })}
                    timeFormat=""
                    className="form-control"
                    timeIntervals={15}
                    dateFormat="DD/MM/YYYY"
                    disabled={modalVars.disabled}
                    timeCaption="time"
                    customInput={<InputMask name="fecha_inicio" className="form-control" mask="99/99/9999" type="text" />}
                  />
                </div>
                <div className="ui-field">
                  <label>Fecha de vencimiento</label>
                  <DatePicker
                    selected={this.state.fecha_vencimiento}
                    onChange={(e) => this.setState({ 'fecha_vencimiento': moment(e) })}
                    timeFormat=""
                    className="form-control"
                    timeIntervals={15}
                    dateFormat="DD/MM/YYYY"
                    disabled={modalVars.disabled}
                    timeCaption="time"
                    customInput={<InputMask name="fecha_vencimiento" className="form-control" mask="99/99/9999" type="text" />}
                  />
                </div>
              </div>
            </section>

            <section className="ui-section-block ui-section-span-2">
              <h5 className="ui-section-label">Referencia</h5>
              <div className="ui-row-1">
                <div className="ui-field">
                  <label>Detalle</label>
                  <Input
                    type="textarea"
                    name="referencia"
                    value={this.state.referencia}
                    disabled={modalVars.disabled}
                    onChange={(e)=> this.onChangeField('referencia', e.target.value)}
                  />
                  <FormFeedback className={(errors.referencia != undefined ? "d-block" : "")}>{errors.referencia}</FormFeedback>
                </div>
              </div>
            </section>

          {!(this.props.action=="DELETE") &&

            <section className="ui-section-block ui-section-span-2">
              <h5 className="ui-section-label">Documentos</h5>
              {(this.props.action=='DETAIL' || this.props.action=='EDIT') && this.state.documentos.length > 0
                ?
                this.state.documentos.map(el =>
                  <div className="convenio-file-row" key={el.filename}>
                    <span className="convenio-file-icon"><i className="ti ti-file-description" aria-hidden="true"></i></span>
                    <a className="fileName" target="_blank" href={el.path} download>{el.filename}</a>
                    {this.props.action=='EDIT' &&
                    <button type="button" onClick={this.removeDocument} data-remove={el.filename} className="convenio-file-remove" aria-label="Quitar documento">
                      <i className="ti ti-x" aria-hidden="true"></i>
                    </button>
                    }
                  </div>
                )
                :
                <div className="ui-alert ui-alert-info">No hay documentos cargados.</div>
              }
              {(this.props.action == 'EDIT' || this.props.action =='CREATE')
              &&
                <div className="ui-row-1">
                  <div className="ui-field">
                    <label>Agregar documentos</label>
                    <Input
                      type="file"
                      name="documentos"
                      multiple
                      onChange={(e) => this.setState({add_documentos: e.target.files})}
                    />
                  </div>
                </div>
              }

              <FormFeedback className="col-12"></FormFeedback>
            </section>
          }
          </div>
        </div>
      </ParadigmaModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Convenios/Modal.js